import Button from '@rio-cloud/rio-uikit/Button';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import type { ReactNode } from 'react';

const DIALOG_TEXT: Record<TransportOrderDialogMode, { title: string; confirm: string }> = {
    create: { title: 'New transport order', confirm: 'Create order' },
    edit: { title: 'Edit transport order', confirm: 'Save changes' },
};

export type TransportOrderDialogMode = 'create' | 'edit';

export type TransportOrderDialogProps = {
    show: boolean;
    mode: TransportOrderDialogMode;
    children?: ReactNode;
    disableConfirm?: boolean;
    onClose: () => void;
    onConfirm: () => void;
};

const TransportOrderDialog = ({
    show,
    mode,
    children,
    disableConfirm = false,
    onClose,
    onConfirm,
}: TransportOrderDialogProps) => {
    const { title, confirm } = DIALOG_TEXT[mode];

    const footer = (
        <div className='display-flex justify-content-end gap-10'>
            <Button onClick={onClose}>Cancel</Button>
            <Button bsStyle={Button.PRIMARY} disabled={disableConfirm} onClick={onConfirm}>
                {confirm}
            </Button>
        </div>
    );

    return (
        <Dialog
            show={show}
            title={title}
            bsSize={Dialog.SIZE_SM}
            body={children}
            footer={footer}
            onClose={onClose}
            showCloseButton
            useOverflow
        />
    );
};

export default TransportOrderDialog;
